(function (win, $) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    fp.home = (function () {

        // =========================================
        // Get screen size
        // =========================================
        const getScreenSize = function () {
            const pixelDensity = window.devicePixelRatio || 1;
            const width = window.innerWidth * pixelDensity;

            if (width >= 2400) return 'xlarge';
            if (width >= 1400) return 'large';
            if (width >= 1000) return 'medium';
            if (width >= 600) return 'small';
            return 'xsmall';
        };

        // =========================================
        // Set video controls
        // =========================================
        var setupVideoControls = function () {
            var video = document.getElementById('bg-video');
            var videoButton = document.getElementById('video-pause-play');
            var videoButtonIcon = videoButton.querySelector('span');
            var controlAnnouncements = document.getElementById('video-control-announcements');

            if (!video || !videoButton || !controlAnnouncements) {
                return;
            }

            videoButton.addEventListener('click', function () {
                if (!video.paused) {
                    video.pause();
                    videoButton.setAttribute('aria-label', 'Play video');
                    videoButtonIcon.classList.replace('icon-pause', 'icon-play');
                    controlAnnouncements.textContent = 'Video paused';
                } else {
                    video.play();
                    videoButton.setAttribute('aria-label', 'Pause video');
                    videoButtonIcon.classList.replace('icon-play', 'icon-pause');
                    controlAnnouncements.textContent = 'Video playing';
                }
            });
        };

        // =========================================
        // Set background image
        // =========================================
        const setBgImage = function (imgInfo = []) {
            const screenSize = getScreenSize();
            const filteredImages = imgInfo.filter((img) => img.assetSize === screenSize);
            if (!filteredImages.length) return;

            const randomNumber = Math.floor(Math.random() * filteredImages.length);
            const randomBackgroundImage = filteredImages[randomNumber];

            // Select only .slideshow.slideshow-photo
            const slideshowPhotoEl = document.querySelector('.slideshow.slideshow-photo');

            // Exit if .slideshow.slideshow-photo is not available
            if (!slideshowPhotoEl) return;

            // Set the background image
            slideshowPhotoEl.style.backgroundImage = `url('${randomBackgroundImage.imagePath}')`;

            // Set accessibility attributes
            if (randomBackgroundImage.altText) {
                slideshowPhotoEl.setAttribute('aria-label', randomBackgroundImage.altText);
                slideshowPhotoEl.setAttribute('role', 'img');
            }
        };

        return {
            init: function () {
                let initialLoad = true;
                $('.homepage-link').addClass('selected');

                const jqUpdateSize = function () {
                    const height = $(window).height();
                    const announcementHeight = $('.message-banner').length ? $('.message-banner').outerHeight() : 0;
                    const extraHeight = $('#width-detection').css('float') === 'left'
                        ? 0
                        : $('#utility').outerHeight() + $('#header').outerHeight();

                    $('.slideshow-wrapper').css('height', height - announcementHeight - extraHeight);

                    if (initialLoad) {
                        $('body').removeClass('fade-home-contents');
                        initialLoad = false;
                        setTimeout(() => $('body').addClass('hero-set'), 1000);
                    }
                };

                jqUpdateSize();
                $(window).resize(jqUpdateSize);

                // Initialize video controls
                setupVideoControls();
            },

            setBgImage: setBgImage
        };
    })();
})(window, $);